module.exports = __webpack_public_path__ + "img/logo_color.67870afd.png";